/**
 * Resolve API base URL for customer/lab installs.
 * Prefer runtime App Service config over CRA bake-time env.
 */
export function resolveTrustvidApiUrl({
  runtimeApiUrl,
  bakeTimeApiUrl,
} = {}) {
  const runtime = String(runtimeApiUrl || "").trim().replace(/\/+$/, "");
  if (runtime) return runtime;
  return String(bakeTimeApiUrl || "").trim().replace(/\/+$/, "");
}

export function readRuntimeApiUrlFromWindow(win = typeof window !== "undefined" ? window : undefined) {
  return win?.__TRUSTVID_RUNTIME__?.apiUrl || "";
}
